import React from 'react';
import App from 'App';
import { createRoot } from 'react-dom/client';

// create application root and render contents
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);